export const singlePlanTable = {
  title: 'How our policy compares to a standard guarantee',
  subheading1: "What's included",
  subheading2: 'Guarantee ({{ warrantyInMonths }} mths)',
  subheading3: 'Appliance Care',
  breakdowns: 'Only for breakdowns',
};
